import React from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

import { tabsListVariants, tabsTriggerStyles } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

const tabs = [
  { nameKey: 'patients.tabs.overview', link: 'overview' },
  { nameKey: 'patients.tabs.appointments', link: 'appointments' },
  { nameKey: 'patients.tabs.documents', link: 'documents' },
] as const;

const ProfileTabLink: React.FC<{ to: string; children: React.ReactNode }> = ({
  to,
  children,
}) => {
  const resolved = useResolvedPath(to);
  const isActive = useMatch({ path: resolved.pathname, end: false });

  return (
    <Link
      to={to}
      aria-current={isActive ? 'page' : undefined}
      data-state={isActive ? 'active' : 'inactive'}
      className={tabsTriggerStyles}
    >
      {children}
    </Link>
  );
};

export const ProfileTabNav: React.FC = () => {
  const { t } = useTranslation();
  return (
    <nav
      aria-label={t('patients.profile.sectionsAriaLabel')}
      className="group/tabs"
      data-orientation="horizontal"
    >
      <div data-variant="default" className={tabsListVariants()}>
        {tabs.map((tab) => (
          <ProfileTabLink key={tab.link} to={tab.link}>
            {t(tab.nameKey)}
          </ProfileTabLink>
        ))}
      </div>
    </nav>
  );
};
